type UUIDCrypto = {getRandomValues:Crypto['getRandomValues'];randomUUID?:()=>string};
// Older Safari provides secure random bytes but does not provide randomUUID.
// Install before the app and Dillo create message or realtime identifiers.
export function installUUIDFallback(target:UUIDCrypto|undefined){
  if(!target||typeof target.randomUUID==='function'||typeof target.getRandomValues!=='function')return;
  Object.defineProperty(target,'randomUUID',{configurable:true,value:()=>{
    const bytes=target.getRandomValues(new Uint8Array(16));
    bytes[6]=(bytes[6]&0x0f)|0x40;
    bytes[8]=(bytes[8]&0x3f)|0x80;
    const hex=Array.from(bytes,b=>b.toString(16).padStart(2,'0')).join('');
    return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
  }});
}
installUUIDFallback(globalThis.crypto);
